// extracted by mini-css-extract-plugin
module.exports = {"root":"AspectRatio-module__root___cDU5B","wrapper":"AspectRatio-module__wrapper___Qn5vk","inner":"AspectRatio-module__inner___ocAD2"};